<template>
    <section class="ratings" v-if="isUserProfile && currentUser">
        <div class="ratings__wrapper">
            <div class="ratings__title-wrapper">
                <h2 class="ratings__title">Рейтинг лучших участников</h2>
                <TitleBackgroundMobile class="ratings__title-background" v-if="isMobile" />
                <TitleBackground class="ratings__title-background" v-else />
            </div>
            <div class="ratings__wrapper-block">
                <CardUser :user="currentUserFull" />
            </div>
            <Banner class="ratings__banner" v-if="!isMobile" />
            <div class="ratings__filters-mobile" v-if="isMobile" v-click-outside="hideFilters">
                <div
                    class="ratings__btn-open-filter"
                    :class="{ 'ratings__btn-open-filter--filled': filterRegion }"
                    @click="openFilter('region')"
                >
                    По регионам
                </div>
                <div
                    class="ratings__btn-open-filter"
                    :class="{ 'ratings__btn-open-filter--filled': filterProject }"
                    @click="openFilter('project')"
                >
                    По проектам
                </div>
                <div v-if="openedFilter" class="ratings__filters-mobile-selects" @click.stop>
                    <ModelAutoComplete
                        v-if="openedFilter === 'region'"
                        label="Регион"
                        :value="filterRegion"
                        :item-selected="filterRegion"
                        :items="optionsRegions"
                        @debounce-end="inputRegion"
                        @change="changeRegion"
                        :vizKeyPath="[['name']]"
                        :valKeyPath="[['id']]"
                        @click="optionsRegions = filterOptionsRegions"
                        withClear
                    />
                    <ModelAutoComplete
                        v-if="openedFilter === 'project'"
                        label="Участие в проектах"
                        :value="filterProject"
                        :item-selected="filterProject"
                        :items="optionsProjects"
                        @debounce-end="inputProject"
                        @change="changeProject"
                        :vizKeyPath="[['name']]"
                        :valKeyPath="[['id']]"
                        @click="optionsProjects = filterOptionsProjects"
                        withClear
                    />
                </div>
            </div>
            <div class="ratings__wrapper-block ratings__wrapper-block--ratings">
                <div v-if="!isMobile" class="ratings__filters">
                    <ModelAutoComplete
                        v-if="optionsRegions"
                        label="Регион"
                        :value="filterRegion"
                        :item-selected="filterRegion"
                        :items="optionsRegions"
                        @debounce-end="inputRegion"
                        @change="changeRegion"
                        :vizKeyPath="[['name']]"
                        :valKeyPath="[['id']]"
                        @click="optionsRegions = filterOptionsRegions"
                        withClear
                    />
                    <ModelAutoComplete
                        v-if="optionsProjects"
                        label="Участие в проектах"
                        :value="filterProject"
                        :item-selected="filterProject"
                        :items="optionsProjects"
                        @debounce-end="inputProject"
                        @change="changeProject"
                        :vizKeyPath="[['name']]"
                        :valKeyPath="[['id']]"
                        @click="optionsProjects = filterOptionsProjects"
                        withClear
                    />
                </div>
                <div class="ratings__position-users" v-if="users.length && !isLoadingUsers" key="position-users">
                    <div class="ratings__position-user" v-for="user in users" :key="user.id">
                        <PositionUser :user="user" />
                    </div>
                </div>
                <div v-else-if="!isLoadingUsers" class="ratings__no-data" key="no-data">
                    Нет данных. Попробуйте изменить параметры поиска.
                </div>
                <div v-else class="ratings__loader" v-loading.small="isLoadingUsers" key="loader" />
                <button class="ratings__shor-more-button" @click="btnShowMore" v-if="isBtnShowMore && users.length">
                    Еще результаты
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M2 14C2 14 2.12132 14.8492 5.63604 18.364C9.15076 21.8787 14.8492 21.8787 18.364 18.364C19.6092 17.1187 20.4133 15.5993 20.7762 14M2 14V20M2 14H8M22 10C22 10 21.8787 9.15076 18.364 5.63604C14.8492 2.12132 9.15076 2.12132 5.63604 5.63604C4.39076 6.88131 3.58669 8.40072 3.22383 10M22 10V4M22 10H16"
                            stroke="#4663AB"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </button>
            </div>
            <div class="ratings__wrapper-block" v-if="isMobile">
                <Banner />
            </div>
        </div>
    </section>
</template>

<script>
import TitleBackground from '../components/ratings/svg/TitleBackground.vue';
import TitleBackgroundMobile from '../components/ratings/svg/TitleBackgroundMobile.vue';
import PositionUser from '../components/ratings/PositionUser.vue';
import { mapGetters } from 'vuex';
import CardUser from '../components/ratings/CardUser.vue';
import { get, post } from '@/tools/http';
import Banner from '../components/ratings/Banner.vue';
// import BannerMobile from '../components/ratings/BannerMobile.vue';
import ModelAutoComplete from '@/components/UI/models/ModelAutoComplete';

const TAKE_FOR_FETCH = 30;

export default {
    components: {
        TitleBackground,
        TitleBackgroundMobile,
        CardUser,
        PositionUser,
        Banner,
        // BannerMobile,
        ModelAutoComplete,
    },
    Bannere: 'Ratings',
    data() {
        return {
            usersFull: [],
            users: [],
            currentUser: null,
            skip: 0,
            takeForTemplate: 10,
            searchRegion: [],
            searchProject: [],
            filterRegion: null,
            filterProject: null,
            optionsRegions: [],
            filterOptionsRegions: [],
            optionsProjects: [],
            filterOptionsProjects: [],
            openedFilter: null,
            isLoadingUsers: false,
            isFetchShowMore: true,
        };
    },
    computed: {
        ...mapGetters(['isMobile', 'userProfileId', 'userProfileInfo']),
        currentUserFull() {
            if (this.isUserProfile) {
                return { ...this.currentUser, ...this.userProfileInfo };
            }
            return null;
        },
        isUserProfile() {
            return Object.keys(this.userProfileInfo).length;
        },
        isBtnShowMore() {
            return this.users.length < this.usersFull.length;
        },
    },
    methods: {
        openFilter(filter) {
            this.openedFilter = filter;
        },
        hideFilters() {
            if (this.openedFilter) {
                this.openedFilter = null;
            }
        },
        inputRegion(text) {
            this.optionsRegions = this.filterOptionsRegions;
            if (text.value) {
                const filterRegions = this.filterOptionsRegions.filter((region) => {
                    if (region.name) {
                        return region.name.indexOf(text.value) !== -1;
                    }
                    return false;
                });
                this.optionsRegions = filterRegions;
            } else {
                this.optionsRegions = this.filterOptionsRegions;
            }
        },
        async changeRegion(value) {
            this.isLoadingUsers = true;
            this.openedFilter = null;
            this.optionsRegions = this.filterOptionsRegions;
            this.filterRegion = this.filterOptionsRegions.find((region) => region.id === value);
            await Promise.all([this.loadUsers(), this.fetchCurrentUser()]);
            this.isLoadingUsers = false;
            this.isFetchShowMore = true;
        },
        inputProject(text) {
            this.optionsProjects = this.filterOptionsProjects;
            if (text.value) {
                const filterProjects = this.filterOptionsProjects.filter((project) => {
                    if (project.name) {
                        return project.name.indexOf(text.value) !== -1;
                    }
                    return false;
                });
                this.optionsProjects = filterProjects;
            } else {
                this.optionsProjects = this.filterOptionsProjects;
            }
        },
        async changeProject(value) {
            this.isLoadingUsers = true;
            this.openedFilter = null;
            this.optionsProjects = this.filterOptionsProjects;
            this.filterProject = this.filterOptionsProjects.find((project) => project.id === value);
            await Promise.all([this.loadUsers(), this.fetchCurrentUser()]);
            this.isLoadingUsers = false;
            this.isFetchShowMore = true;
        },
        async btnShowMore() {
            // Получить следующие this.takeForTemplate юзеров
            const users = this.usersFull.slice(this.skip, this.skip + this.takeForTemplate);

            // Добавить юзеров в this.users
            users.forEach((user) => {
                this.users.push(user);
            });

            // Сколько уже выведено юзеров
            this.skip += this.takeForTemplate;
            if (this.usersFull.length - this.users.length <= this.takeForTemplate - 1 && this.isFetchShowMore) {
                await this.loadUsers(true);
            }
        },
        async fetchUsers(skip) {
            const query = [];

            if (this.filterRegion) {
                query.push(`regionFiasId=${this.filterRegion.id}`);
            }

            if (this.filterProject) {
                query.push(`partnerId=${this.filterProject.id}`);
            }

            // Запрашиваем юзеров рейтинга
            const users = await get(
                'coins',
                `api/Participant?skip=${skip}&take=${TAKE_FOR_FETCH}${query ? '&' : ''}${query.join('&')}`,
                {},
                true
            );

            if (users.length < TAKE_FOR_FETCH && this.usersFull.length) {
                this.isFetchShowMore = false;
            }

            return users;
        },
        async loadUsers(isGetNextItems = false) {
            let skip;
            if (isGetNextItems) {
                skip = this.usersFull.length;
            } else {
                skip = 0;
            }

            const users = await this.fetchUsers(skip);

            if (isGetNextItems) {
                this.usersFull = [...this.usersFull, ...users];
            } else {
                // Выводим юзеров
                this.usersFull = users;
                this.users = users.slice(0, this.takeForTemplate);
                this.skip = this.takeForTemplate;
            }

            return users;
        },
        async fetchCurrentUser(isInit = false) {
            const query = [];

            if (this.filterRegion) {
                query.push(`regionFiasId=${this.filterRegion.id}`);
            }

            if (this.filterProject) {
                query.push(`partnerId=${this.filterProject.id}`);
            }

            const currentUser = await get('coins', `api/Participant/current?${query.join('&')}`, {}, true);

            if (currentUser) {
                this.currentUser = currentUser;
            } else if (isInit) {
                this.$router.push({ name: '404' });
            } else {
                this.currentUser.ratingPosition = '-';
                this.currentUser.totalCoins = '-';
            }
        },

        async dictionary() {
            const regions = await get('coins', `api/Participant/regions`, {}, true);
            const projects = await get('coins', `api/Partner/list`, {}, true);
            this.optionsRegions = regions;
            this.filterOptionsRegions = regions;
            this.optionsProjects = projects;
            this.filterOptionsProjects = projects;
        },
        async init() {
            await Promise.all([this.fetchCurrentUser(true), this.loadUsers(), this.dictionary()]);
        },
    },
    async created() {
        this.isLoadingUsers = true;
        await this.init();
        this.isLoadingUsers = false;
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';
@import '~@/styles/variables';

.ratings {
    padding-top: mrem(16);

    * {
        font-family: 'Montserrat', sans-serif;
    }

    @include on-desktop {
        padding: 0;
        padding-bottom: rem(50);
        background: white;
    }

    &__wrapper {
        padding-top: mrem(16);
        border-top-left-radius: mrem(16);
        border-top-right-radius: mrem(16);
        background: white;
        min-height: 100vh;
        min-height: 100dvh;
        min-width: 100vw;
        min-width: 100dvw;

        @include on-desktop {
            width: rem(1608);
            margin: 0 auto;
            min-width: 0;
            padding-top: rem(50);

            display: grid;
            grid-template-columns: rem(440) rem(1050);
            grid-template-rows: rem(113) rem(340) min-content;
            gap: rem(40);
        }
    }

    &__wrapper-block {
        padding: mrem(20);

        &--ratings {
            padding-top: mrem(15);
            padding-bottom: 0;
        }

        @include on-desktop {
            padding: 0;

            &--ratings {
                grid-column: 2 / -1;
                grid-row: 2 / -1;
            }
        }
    }

    &__filters {
        ::v-deep * {
            font-family: inherit;
        }

        @include on-desktop {
            display: flex;
            align-items: center;
            gap: rem(20);
        }
    }

    &__no-data {
        font-size: mrem(16);
        line-height: mrem(24);
        padding: mrem(12) mrem(20);
        background: #f7f9fc;

        @include on-desktop {
            font-size: rem(16);
            line-height: rem(24);
            padding: rem(12) rem(20);
            margin-top: rem(40);
        }
    }

    &__title-wrapper {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: relative;

        @include on-desktop {
            grid-column: 1 / -1;
        }
    }

    &__title {
        width: mrem(300);
        margin: 0;
        font-size: mrem(24);
        line-height: mrem(32);
        font-weight: 700;
        padding: mrem(8) mrem(20);
        position: relative;
        z-index: 1;

        @include on-desktop {
            font-size: rem(56);
            line-height: rem(66);
            padding: rem(14) 0;
            width: auto;
        }
    }

    &__loader {
        margin: mrem(20) auto;
        height: mrem(100);

        @include on-desktop {
            margin: rem(20) auto;
            margin-top: rem(40);
            height: rem(100);
        }
    }

    &__banner {
        @include on-desktop {
            grid-row: 3 / -1;
        }
    }

    &__title-background {
        width: mrem(373);
        height: mrem(80);
        position: absolute;
        top: 0;
        left: 0;

        @include on-desktop {
            width: rem(1419);
            height: rem(93);
            left: 50%;
            transform: translateX(-50vw);
        }
    }

    &__position-users {
        @include on-desktop {
            margin-top: rem(10);
        }
    }

    &__position-user {
        border-bottom: mrem(1) solid #d6e0ea;

        &:last-of-type {
            border-bottom: none;
        }

        @include on-desktop {
            border-bottom: rem(1) solid #d6e0ea;
        }
    }

    &__filters-mobile {
        padding: mrem(10) mrem(20);
        text-align: center;
        background: #ebf0f5;
        min-height: mrem(56);
        display: flex;
        gap: mrem(20);
        position: relative;
        justify-content: space-between;
        z-index: 1;

        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateY(-50%);
            width: mrem(1);
            height: mrem(40);
            z-index: 1;
            background: #b3caf3;
            display: block;

            @include on-desktop {
                display: none;
            }
        }
    }

    &__filters-mobile-selects {
        position: absolute;
        top: 90%;
        left: mrem(20);
        width: calc(100% - 5.06329rem - 5.06329rem);
        background: white;
        padding: mrem(5) mrem(15);
        border-radius: mrem(10);
        box-shadow: 0 mrem(2) mrem(16) 0 rgba(70, 99, 171, 0.1);

        ::v-deep * {
            font-family: inherit;
        }
    }

    &__btn-open-filter {
        background: #f6fafd;
        font-family: 'Montserrat', sans-serif;
        font-weight: 700;
        font-size: mrem(16);
        line-height: mrem(20);
        color: #4663ab;
        padding: mrem(10) mrem(20);
        border-radius: mrem(16);
        min-height: mrem(36);

        &--filled {
            background: #4663ab;
            color: white;
        }
    }

    &__shor-more-button {
        font-family: 'Montserrat', sans-serif;
        font-weight: 600;
        font-size: mrem(14);

        line-height: mrem(20);
        text-align: center;
        color: #4663ab;
        border: mrem(1) solid #4663ab;
        border-radius: mrem(10);
        padding: mrem(9);
        height: mrem(42);
        width: 100%;
        background: none;
        margin-top: mrem(24);

        display: flex;
        align-items: center;
        justify-content: center;
        gap: mrem(6);
        cursor: pointer;

        svg {
            width: mrem(22);
            height: mrem(22);
        }

        @include on-desktop {
            font-size: rem(14);

            line-height: rem(24);
            border: rem(1) solid #4663ab;
            border-radius: rem(10);
            padding: rem(14) rem(32);
            height: rem(48);
            gap: rem(6);
            margin-top: rem(40);
            width: auto;
            margin-left: auto;
            margin-right: auto;

            svg {
                width: rem(22);
                height: rem(22);
            }
        }
    }
}
</style>
